export default __webpack_public_path__ + "static/media/underconstruction.a4ecf82c.png";